enum StatusColeta {
    Pendente = 1,
    Coletado = 2,
}

export default StatusColeta;
